<template>
<div class="chapter">
<div class="inner_page">
<h1 class="PART-TITLE">Getting Started</h1>
<p class="INTRO1">Now you’ve been inspired by The Gallery, get crocheting – choose your yarn, grab a hook and pick a design or several. The easy-to-follow patterns will help you create a collection of amazing motifs to use as gifts, fashion accessories and fun household features. For extra help, check out the Basic Stitches guide within this chapter and the Conversion Charts at the back of the book. Most importantly, remember Michelle, Cécile and Sylvie’s simple motto: always crochet with a passion!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter2.vue?4f7b8a4a